import { useEffect, useRef } from 'react';
import { trackViewableImpression, IMPRESSION_DELAY_THRESHOLD, VISIBILITY_THRESHOLD } from 'ai/analytics/trackers/impressionTrackers';

const useViewableImpression = ({ componentRef, prompts = [], sotFields = {}, dependencies = [] }) => {
    const impressionTracked = useRef(false);
    const visibilityTimerRef = useRef(null);

    useEffect(() => {
        if (!componentRef?.current || impressionTracked.current || typeof window === 'undefined' || !('IntersectionObserver' in window)) {
            return undefined;
        }

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD && !impressionTracked.current) {
                        if (visibilityTimerRef.current) {
                            clearTimeout(visibilityTimerRef.current);
                        }

                        visibilityTimerRef.current = setTimeout(() => {
                            if (componentRef?.current) {
                                const rect = componentRef.current.getBoundingClientRect();
                                const stillVisible = rect.top < window.innerHeight && rect.bottom > 0;

                                if (stillVisible && !impressionTracked.current) {
                                    impressionTracked.current = true;
                                    trackViewableImpression({ prompts, sotFields });
                                }
                            }
                        }, IMPRESSION_DELAY_THRESHOLD);
                    }
                });
            },
            { threshold: VISIBILITY_THRESHOLD }
        );

        observer.observe(componentRef.current);

        const cleanup = () => {
            if (visibilityTimerRef.current) {
                clearTimeout(visibilityTimerRef.current);
            }

            observer.disconnect();
        };

        return cleanup;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentRef?.current, prompts, JSON.stringify(sotFields), ...dependencies]);
};

export default useViewableImpression;
